import * as Actions from '../Actions/ConfirmacaoActions';

const initialState = {
    mensagem : null,
    response : null, 
    data     : null,   
    
};

const ConfirmacaoReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.OPEN_CONFIRMACAO_DIALOG:
        {
            return {
                ...state,
                mensagem : action.mensagem,
                response : action.response,   
                id: action.id,   
            };
        }
        case Actions.CLOSE_CONFIRMACAO_DIALOG:
        {
            return {
                ...state,
                mensagem : null,
                response : null,
                id: null,   
            };
        }
        default:
        {
            return state;
        }
    }
};

export default ConfirmacaoReducer;
